import { render, staticRenderFns } from "./ModalExtra.vue?vue&type=template&id=4334cfe4&"
import script from "./ModalExtra.vue?vue&type=script&lang=js&"
export * from "./ModalExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports